export default () => {
    'use strict';

    if (typeof document === 'undefined') return;

    function initCardLinks(scope) {
        scope = scope || document;
        const cards = scope.querySelectorAll('.form-layout__cards .form-layout__card');

        if (!cards || !cards.length) return;

        cards.forEach(function (card) {
            const link = card.querySelector('.form-layout__link a[href]') || card.querySelector('a[href]');
            if (!link) return;

            // Ensure safe behaviour for target="_blank"
            if (link.target === '_blank' && (!link.rel || !/noopener/i.test(link.rel))) {
                link.rel = (link.rel ? link.rel + ' ' : '') + 'noopener noreferrer';
            }

            // Accessibility
            if (!card.hasAttribute('role')) card.setAttribute('role', 'link');
            if (!card.hasAttribute('tabindex')) card.tabIndex = 0;
            if (!card.getAttribute('aria-label')) {
                const label = (link.getAttribute('aria-label') || link.textContent || link.href || '').trim();
                if (label) card.setAttribute('aria-label', label);
            }

            function navigate() {
                // If the link has target _blank, open safely
                if (link.target === '_blank') {
                    window.open(link.href, '_blank', 'noopener');
                } else {
                    window.location.href = link.href;
                }
            }

            card.addEventListener('click', function (e) {
                // Let inner interactive elements behave normally
                if (e.target.closest('a, button, input, select, textarea, label')) return;
                // Respect modifier clicks (open in new tab/window)
                if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                e.preventDefault();
                navigate();
            }, false);

            card.addEventListener('keydown', function (e) {
                const key = e.key || e.keyCode;
                // Enter or Space activates link
                if (key === 'Enter' || key === ' ' || key === 'Spacebar' || key === 13 || key === 32) {
                    e.preventDefault();
                    // Allow modifier use with keyboard (e.g. Ctrl+Enter)
                    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
                    navigate();
                }
            }, false);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initCardLinks(); });
    } else {
        initCardLinks();
    }

    // Expose manual initializer if needed
    if (typeof window !== 'undefined') {
        window.initCardLinks = initCardLinks;
    }
}